<template>
  <div
    data-aos="fade-in"
    data-aos-easing="ease-in-out"
    data-aos-duration="500"
    class="grid gap-4 lg:grid-cols-2 md:grid-cols-1 mt-10"
  >
    <div v-for="file in careersFiles" :key="file.id">
      <JobPosting
        :header="file.header"
        :date="file.date"
        :identifier="file.id"
      />
    </div>
  </div>
</template>

<script>
import JobPosting from "./JobPosting.vue";

export default {
  name: "JobPostings",
  props: {
    careersFiles: Array,
  },
  components: {
    JobPosting,
  },
};
</script>

